import { Suspense, lazy } from 'react';
import CommonSkeleton from 'components/common/skeleton/CommonSkeleton';

const EndUserScanReportIndex = lazy(
	() => import('components/report/endUserScanReport/EndUserScanReportIndex'),
);

const EndUserReportPage = () => {
	return (
		<div className='page-content user-module'>
			<Suspense fallback={<CommonSkeleton />}>
				<EndUserScanReportIndex />
			</Suspense>
		</div>
	);
};
export default EndUserReportPage;
